import styled from "styled-components";

export const DealerContainer = styled.div`
  padding: 32px 0;
  .item {
    background: #fff;
    border: solid 1px ${({ theme }) => theme.colors.lightFont};
    margin: 16px 0;
    border-radius: 10px;
    cursor: pointer;
    padding: 16px;
    .text,
    .province-city {
      font-weight: bold;
    }
    &:hover {
      border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
      
    }
  }
  .not-allowed {
    cursor: not-allowed;
    opacity: 0.5;
  }
  .selected {
    border: solid 1px ${({ theme }) => theme.colors.btnPrimaryBg};
    cursor: default;
  }
  .buttons {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
  }
`;
